import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

export interface ThemeBadgeProps {
  isPrimary?: boolean;

  /**
   * TODO: 다크모드 지원 색상으로 안되어있어 아직 구현 안함
   */
  isSecondary?: boolean;

  /**
   * TODO: 다크모드 지원 색상으로 안되어있어 아직 구현 안함
   */
  isLine?: boolean;

  /**
   * TODO: 다크모드 지원 색상으로 안되어있어 아직 구현 안함
   */
  isRed?: boolean;
  label: string;
  className?: string;
}

export function ThemeBadge({
  isPrimary,
  isSecondary,
  isLine,
  isRed,
  label,
  className,
  ...props
}: ThemeBadgeProps) {
  return (
    <Text
      className={twMerge(
        'font-x-small2-bold',
        'inline-flex h-16pxr items-center justify-center rounded-5pxr',
        'px-3pxr',
        isPrimary &&
          !isSecondary &&
          !isLine &&
          !isRed &&
          'bg-theme-solid-100 text-theme-solid-0',
        !isPrimary &&
          isSecondary &&
          !isLine &&
          !isRed &&
          'bg-theme-solid-20 text-theme-solid-100',
        isLine && 'border-1 border-theme-solid-10',
        !isPrimary && !isSecondary && isRed && 'text-static-point-red',
        className
      )}
      {...props}
    >
      {label}
    </Text>
  );
}
